(() => {
  const DAY = 86400000;

  const frequencyMs = value => {
    if (value === '1d') return DAY;
    if (value === '7d') return DAY * 7;
    if (value === '30d') return DAY * 30;
    return 0;
  };

  const copyText = async value => {
    if (!value) return false;
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (_) {
      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.append(textarea);
      textarea.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (_) {}
      textarea.remove();
      return ok;
    }
  };

  const initPopup = popup => {
    if (!popup || popup.dataset.dotoInitialized === 'true') return;
    popup.dataset.dotoInitialized = 'true';

    const key = `doto_promo_popup_${popup.dataset.campaignKey || 'default'}`;
    const frequency = popup.dataset.frequency || '7d';
    const delay = Number(popup.dataset.delay || 0);
    const editor = popup.dataset.editor === 'true' || Boolean(window.Shopify?.designMode);
    const dialog = popup.querySelector('.doto-promo-popup__dialog');
    const copyButton = popup.querySelector('[data-copy-coupon]');
    const couponCode = popup.querySelector('[data-coupon-code]');
    let lastFocus = null;

    const storage = frequency === 'session' ? window.sessionStorage : window.localStorage;

    const shouldOpen = () => {
      if (editor || frequency === 'always') return true;
      try {
        const stored = Number(storage.getItem(key) || 0);
        if (!stored) return true;
        if (frequency === 'session') return false;
        return Date.now() - stored >= frequencyMs(frequency);
      } catch (_) {
        return true;
      }
    };

    const remember = () => {
      if (editor || frequency === 'always') return;
      try { storage.setItem(key, String(Date.now())); } catch (_) {}
    };

    const open = () => {
      if (!popup.hidden && popup.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('doto-promo-popup-lock');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        dialog?.focus({ preventScroll: true });
      });
    };

    const close = () => {
      popup.classList.remove('is-open');
      remember();
      document.body.classList.remove('doto-promo-popup-lock');
      window.setTimeout(() => { popup.hidden = true; }, 260);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    };

    popup.querySelectorAll('[data-popup-close]').forEach(el => el.addEventListener('click', close));

    if (copyButton && couponCode) {
      copyButton.addEventListener('click', async () => {
        const original = copyButton.dataset.copyLabel || copyButton.textContent.trim();
        const copied = copyButton.dataset.copiedLabel || 'Copiado ✓';
        const ok = await copyText(couponCode.textContent.trim());
        if (!ok) return;
        copyButton.textContent = copied;
        copyButton.classList.add('is-copied');
        window.setTimeout(() => {
          copyButton.textContent = original;
          copyButton.classList.remove('is-copied');
        }, 1800);
      });
    }

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (shouldOpen()) {
      window.setTimeout(open, editor ? 150 : delay);
    }

    document.addEventListener('shopify:section:select', event => {
      if (event.detail?.sectionId === popup.id.replace('DotoPromoPopup-', '')) open();
    });
  };

  const initAll = root => {
    (root || document).querySelectorAll?.('[data-doto-promo-popup]').forEach(initPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
